import { InfiniteData } from '@tanstack/react-query'

import { QueryChatArgs, Chat, ChatList } from '@tribeplatform/gql-client/types'

import { UseQueryOptions, useQuery, useQueryClient } from '../../index.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatKey, getChatsKey } from '../../utils/keys/messaging.key.js'
import { ARCHIVED_CHATS_QUERY, CHATS_QUERY } from './constants.js'

export const useChat = (options: {
  variables: QueryChatArgs
  useQueryOptions?: UseQueryOptions<Chat>
}) => {
  const { variables, useQueryOptions } = options

  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const chatKey = getChatKey({ variables })
  const chatsKey = getChatsKey({ variables: { ...CHATS_QUERY } })
  const archivedChatsKey = getChatsKey({
    variables: { ...ARCHIVED_CHATS_QUERY },
  })

  return useQuery<Chat>(
    chatKey,
    () => {
      const chatsData =
        queryClient.getQueryData<InfiniteData<ChatList>>(chatsKey)
      const archivedChatsData =
        queryClient.getQueryData<InfiniteData<ChatList>>(archivedChatsKey)
      if (chatsData) {
        const chat = chatsData.pages
          .flatMap(page => page.data)
          .find(chat => chat._id === variables.id)

        if (chat) {
          return chat
        }
      }

      if (archivedChatsData) {
        const chat = archivedChatsData.pages
          .flatMap(page => page.data)
          .find(chat => chat._id === variables.id)

        if (chat) {
          return chat
        }
      }

      return client.messaging.chat(variables)
    },
    {
      ...useQueryOptions,
    },
  )
}
